import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme/booking-theme';

const useStyles = makeStyles({
  rootStateroomCard: {
    height: 'auto',
    display: 'flex',
    minHeight: '275px',
    flexWrap: 'wrap',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2,
    padding: '24px 16px',

    [theme.breakpoints.up('md')]: {
      padding: '24px',
    },

    '& .header': {
      '& .title': {
        color: theme.palette.blue1,
        fontFamily: theme.typography.proxima.semiBold,
        fontSize: theme.typography.pxToRem(24),
        lineHeight: '150%',
        margin: 0,
      },
    },

    '& .content': {
      display: 'flex',
      padding: '16px 0 0',
      flexDirection: 'column',
    },

    '& .button-container': {
      padding: 0,
      '& button': {
        height: 50,
        '& span': {
          [theme.breakpoints.between('md', 'lg')]: {
            fontSize: theme.typography.pxToRem(15),
            lineHeight: theme.typography.pxToRem(18),
          },
        },
      },
    },

    '& .room-labels': {
      display: 'flex',
      flexWrap: 'wrap',

      '&__label': {
        color: theme.palette.grey1,
        fontSize: theme.typography.pxToRem(16),
        lineHeight: '150%',
        paddingRight: 8,

        '&::after': {
          content: '", "',
        },

        '&:last-of-type': {
          '&::after': {
            content: '""',
          },
        },

        '&.guarantee': {
          '&::after': {
            content: '""',
            padding: '0 5px',
          },
        },
      },
    },

    '& .title-container': {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  cardImg: {
    width: '34.5%',
    minHeight: '100%',
    objectFit: 'cover',

    [theme.breakpoints.down('lg')]: {
      height: '170px',
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      height: '180px',
    },
  },
  fallbackImg: {
    objectPosition: 'top',
  },
  subtitle: {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(17),
    letterSpacing: '0.5px',
    display: 'block',
    fontWeight: '600',
  },
  contentWrapper: {
    '&:nth-of-type(1)': {
      flex: '1 1 auto',
    },
    '&:nth-of-type(2)': {
      paddingTop: '20px',
      flex: '3 1 auto',
    },
    [theme.breakpoints.down('sm')]: {
      '&:nth-of-type(2)': {
        paddingTop: '20px',
        paddingLeft: 0,
      },
    },
  },

  interactiveGuestNameContainer: {
    marginTop: '10px',
    '& span': {
      cursor: 'pointer',
      fontWeight: '800',
      color: theme.palette.blue2,
      '&:hover': {
        color: theme.palette.blue3,
      },
    },
  },

  plainGuestNameContainer: {
    marginTop: '8px',
  },

  details: {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(16),
    lineheight: '140%',
    textTransform: 'capitalize',

    '&:last-of-type': {
      '&::after': {
        content: '""',
      },
    },
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
});

export default useStyles;
